import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProfileSyncService } from '../../../services/profile-sync.service';
import { Alert } from '../../../../shared/alert.model';
import { getAlertMessage } from '../../../../shared/api-loaders';
import { Transaction } from '../../../model/Transaction';
import { MessageService } from '../../../../shared/message.service';
import { MessageType } from '../../../../shared/messageType';
import { finalize } from 'rxjs/operators';
import { EventEmitterWithValueReturned, EventEmitterWithObservable } from '../../../../shared/EventEmitterWithValueReturned';

@Component({
    selector: 're-profile-sync-list',
    templateUrl: './profile-sync-list.component.html',
    styleUrls: ['./profile-sync-list.component.scss'],
    standalone: false
})
export class ProfileSyncListComponent implements OnInit {

  constructor(private profileSyncService: ProfileSyncService) { }
  ngOnInit(): void {
  }
  load($event: EventEmitterWithObservable) {

    $event.ReturnValue = this.profileSyncService.getTransactions();
  }
}
